export function addClickEvent(clickType, element_text) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'click_event',        // This acts as your event trigger name in GTM
        'click_type': clickType,       // Custom data variable
        'element_text': element_text
    });
    console.log("Added Event:", clickType, element_text)
}